import React, { MouseEvent, useState } from "react";
import { createRoot } from "react-dom/client";

function CopyButton({el}:{el:HTMLSpanElement}){
    const [copied, setCopied] = useState(false);

    async function doCopy(e:MouseEvent){
        try{
            e.preventDefault();
            await navigator.clipboard.writeText(el.innerText?.replace(/\r?\n$/s, ''))
            setCopied(true)
            setTimeout(()=>setCopied(false), 1500)
        }catch(e){}
    }

    return <a className="btn btn-sm btn-info" onClick={doCopy} href="#">
        {!copied && <><i className="far fa-copy"></i>Copy</>}
        {copied && <><i className="fa fa-check"></i>Copied!</>}
    </a>
}

function initButton(element:HTMLDivElement){
    const span = document.createElement('span')
    span.className = 'copy-button'
    element.parentElement.prepend(span);
    const root = createRoot(span);
    root.render(<CopyButton el={element} />)
}

function createApp(){
    const items = document.querySelectorAll('.blog pre > code.hljs') as any 
    [...items].forEach(initButton)

    const links = document.querySelectorAll('.btn-read-more') as any
    [...links].forEach(a => a.addEventListener('click', () => a.previousElementSibling.click()))
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createApp)
} else {
    createApp()
}